import VideoThumbnailImage from '../../assets/img/video/video-thumbnail.jpg';
import VideoThumbnailImageAVIF from '../../assets/img/video/video-thumbnail.avif';
import VideoThumbnailImageWEBP from '../../assets/img/video/video-thumbnail.webp';

/**
 * Capa do vídeo no YouTube. A `maxresdefault` é 16:9 (a `hqdefault` vem com
 * tarjas), mas não existe para todo vídeo — por isso o fallback.
 *
 * @param {string} id
 * @returns {string}
 */
export const youtubeThumbnail = (id) =>
  `https://img.youtube.com/vi/${id}/maxresdefault.jpg`;

/**
 * @param {string} id
 * @returns {string}
 */
export const youtubeThumbnailFallback = (id) =>
  `https://img.youtube.com/vi/${id}/hqdefault.jpg`;

/**
 * @param {string} id
 * @returns {string}
 */
export const youtubeUrl = (id) => `https://www.youtube.com/watch?v=${id}`;

/**
 * Basta o `id` do vídeo: sem `thumbnail`, a capa é puxada do YouTube. Quando o
 * `thumbnail` está preenchido ele tem prioridade, e aí os campos `avif`/`webp`
 * são opcionais.
 *
 * @var object
 */
const videos = [
  {
    id: 'nlDsX47-EHM',
    title: 'Mirrage Nautic Club - Condomínio fechado em Carmo do Cajuru/MG',
    thumbnail: {
      src: VideoThumbnailImage,
      avif: VideoThumbnailImageAVIF,
      webp: VideoThumbnailImageWEBP,
    },
  },
  {
    id: '6pzruOACXQE',
    title: 'Um novo brilho no condomínio Mirrage Nautic Club',
  },
  {
    id: 'oYtxr7Uux7s',
    title: 'Mirrage Nautic Club | Termo de Verificação de Obras (TVO)',
  },
  {
    id: 'R0tEAQq21H8',
    title: 'Lotus Empreendimentos | Institucional',
  },
  {
    id: 'hXJpMvBOork',
    title: 'Mirrage Nautic Club | Yoga Experience',
  },
];

export default videos;
